import axios from "@helpers/axios/public.axios";
import { AUTH, USER } from "../../constants";
import { getWallets, updateWalletEvent } from "@actions/wallet/changeWallet";

export const createDemoUser = () => async (dispatch) => {
  try {
    const response = await axios.post("/register/demo");

    const { user, token } = response.data.data;

    dispatch({
      type: AUTH.AUTH_RESPONSE,
      payload: {
        user,
        token,
        isDemoUser: true,
      },
    });

    dispatch({ type: USER.USER_RESPONSE, payload: { user } });

    await dispatch(getWallets());
    dispatch(updateWalletEvent());

    return {
      user,
      token,
    };
  } catch (e) {
    dispatch({ type: AUTH.AUTH_ERROR, payload: e.response.data.message });
    throw e;
  }
};
